import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/fram1.png")